import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { setClubLeagues, setLeagueCoeffEnabled, setLeagueConfig } from "@/lib/xFactor";

const KEY = "pc_scouting_domain";
const Ctx = createContext({ domain: "women", setDomain: () => {}, coeffVer: 0, reloadCoeff: () => {} });

// Women/Men scouting split. Also keeps the FT X league-coefficient club map in sync with the
// selected domain (two separate maps), so ratings use the correct league per domain.
export function ScoutingDomainProvider({ children }) {
  const [domain, setDomainState] = useState(() => localStorage.getItem(KEY) || "women");
  const [coeffVer, setCoeffVer] = useState(0);

  const loadCoeff = useCallback((dom) => {
    api.get("/settings/ftx-league-coeff", { params: { domain: dom } }).then((r) => {
      setLeagueCoeffEnabled(!!r.data?.enabled);
      setLeagueConfig({ overrides: r.data?.overrides || {}, custom: r.data?.custom || [] });
      setClubLeagues(r.data?.club_leagues || []);
      setCoeffVer((v) => v + 1);
    }).catch(() => {});
  }, []);

  useEffect(() => { loadCoeff(domain); }, [domain, loadCoeff]);

  const setDomain = useCallback((d) => {
    const v = d === "men" ? "men" : "women";
    localStorage.setItem(KEY, v);
    setDomainState(v);
  }, []);
  const reloadCoeff = useCallback(() => loadCoeff(domain), [loadCoeff, domain]);

  return <Ctx.Provider value={{ domain, setDomain, coeffVer, reloadCoeff }}>{children}</Ctx.Provider>;
}

export const useScoutingDomain = () => useContext(Ctx);
